import React from "react";
import {
  Button,
  Typography
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Search as SearchIcon
} from "@mui/icons-material";
import {Link} from "react-router-dom";
import getTrans from "../../../../../languages/getTrans";

const SearchInput = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Button className={classes.search} component={Link} to={`/services`}>
        <SearchIcon color="primary" sx={{fontSize: 24}}/>
        <Typography>{getTrans('dashboardSearchInput.Поиск по сервисам')}</Typography>
      </Button>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 12px",
    boxSizing: "border-box",
  },
  search: {
    gap: "6px",
    width: "100%",
    height: "48px",
    display: "flex",
    padding: "0 12px",
    alignItems: "center",
    borderRadius: "12px",
    background: "#FFFFFF0D",
    boxSizing: "border-box",
    justifyContent: "flex-start",
    border: "1px solid #FFFFFF1A",

    "& .MuiTypography-body1": {
      fontSize: 18,
      opacity: "0.3",
      marginTop: "-4px",
      fontWeight: "400",
      lineHeight: "20px",
      color: theme.palette.text.primary,
    }
  }
}))

export default SearchInput;
